<template>
    <div v-show="isShow">
        <Row style="z-index:9999;float: left;" class="controlDiv">
            <Col>
                <div>
                    <DatePicker type="datetime" :disabled="isSelect" v-model="times" placeholder="选择时间" style="width:172px" @on-open-change="onDataPicker"></DatePicker>

                    <Select v-model="selectModel" :disabled="isSelect"  size="small" style="width:80px" @on-change="selectChange">
                        <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                    <div style="position: relative;" class="iconStyle">
                        <Icon type="ios-rewind" title ="减速*2" @click="shiftDown2()"/>
                        <Icon type="md-arrow-dropleft" title ="减速*1" @click="shiftDown1()"/>
                        <Icon type="ios-arrow-dropright" title="开始回放" v-show="playPause" @click="startPlayback(true)"/>
                        <Icon type="ios-square" title="停止回放"  v-show="!playPause" @click="suspend()"/>
                        <Icon type="md-arrow-dropright" title ="加速*1" @click="expedite1()"/>
                        <Icon type="ios-fastforward" title ="加速*2" @click="expedite2()"/>
                        <input type="text" :value="inputValue" readonly style="width:40px;text-align:center ;font-size: 14px;">
                    </div>
                    <div style="display:inline-block;" class="iconStyle">
                        <!--<Icon type="ios-square" title ="停止回放" @click="stopPlayback()" class="stopStyle"/>-->
                        <img src="../../assets/images/around.png" alt="" title ="拖动" class="lastImg" @mousedown="openDrag" @mouseup="dragStop">
                        <Icon type="ios-film-outline" title ="录屏"  @click="record()"/>
                        <Icon type="md-close" @click="closeControl" title ="关闭"  />
                    </div>
                </div> 
            </Col>
        </Row>
    </div>
</template>
<script>
export default {
    name:"historyPlaybackControl",
    created(){
        this.left = document.documentElement.clientWidth - 50;
        this.top = document.documentElement.clientHeight*0.8;
        //this.onTimer();  
    },
    data() {
        return {
            initTime:"",//初始的设置时间
            isSelect:false,
            isShow:false,
            inputValue:"1.0X",
            inputNumber:1,
            times:"",//时间
            cityList: [
                {
                    value: '正序',
                    label: '正序'
                },
                {
                    value: '倒序',
                    label: '倒序'
                }
            ],
            selectModel: '正序',
            varList:[],//当前点列表
            playPause:true,//播放暂停记录
            openPlayback:false,//启用回放
        }
    },
    mounted() {
        this.$store.registerModule(["system", "historyPlaybackControl"], {
            state: {
                $: this,
            },
        });
        // this.isShow = isShow ? true : false;
    },

    methods: {
        $(x){
            return document.getElementById(x);
        },
        show(data){
            this.isShow = data;
        },
        //正序倒序
        selectChange(){
        },
        //加速*1
        expedite1(){
            if(this.inputNumber>10){
                this.inputNumber = 10;
                this.inputValue = "10.0X";
                return this.$Message.info("已到最大");
            }else{
                this.inputNumber = this.inputNumber+1;
                this.inputValue = this.inputNumber +".0X";
            }
        },
        //加速*2
        expedite2(){
            if(this.inputNumber>10){
                this.inputNumber = 10;
                this.inputValue = "10.0X";
                return this.$Message.info("已到最大");
            }else{
                this.inputNumber = this.inputNumber+2;
                this.inputValue = this.inputNumber +".0X";
            }
        },
        //减速*1
        shiftDown1(){
            if(this.inputNumber<1){
                this.inputNumber = 1;
                this.inputValue = "1.0X";
                return this.$Message.info("已到最小");
            }else{
                this.inputNumber = this.inputNumber-1;
                this.inputValue = this.inputNumber +".0X"; 
            }
        },
        //减速*2
        shiftDown2(){
            if(this.inputNumber<1){
                this.inputNumber = 1;
                this.inputValue = "1.0X";
                return this.$Message.info("已到最小");
            }else{
                this.inputNumber = this.inputNumber-2;
                this.inputValue = this.inputNumber +".0X";
            }
        },
        onTimer(){
            this.setInt = setInterval(function(){
                if(!this.result) return
                if(this.result.varList[0].valueList.length<15 ){
                    this.mark = true;
                    if(this.selectModel == "倒序"){
                        this.end = this.start;
                        this.start = this.start - 100000;
                        if(this.end <  new Date(this.initTime).getTime()){
                            this.suspend();
                            return alert("回放结束")
                        }
                    }else{
                        this.start = this.end;
                        this.end = this.start + 100000;
                        if(this.start >  new Date().getTime()){
                            this.suspend();
                            return alert("回放结束")
                        }
                    }
                    this.startPlayback()
                }
                for(var i =0;i<this.result.varList.length;i++){
                    if(this.result.varList[i].valueList.length == 0){
                        break
                    }
                    if(this.result.varList[i].valueList.length == 0){
                        console.log(this.result.varList[i].varName+":无历史数据！")
                    }
                    if(this.selectModel == "倒序"){
                        var tag = this.result.varList[i].valueList.splice(-this.inputNumber,this.inputNumber);
                    }else{
                        var tag = this.result.varList[i].valueList.splice(0,this.inputNumber);
                    }
                    this.times = new Date(tag[0].TIME);
                    var varData = tag[tag.length-1];
                    var name = varData.NAME;
                    if(name!=undefined || name!=null){
                        name = name.replace(/\\/g, '.$');
                        //判断是否是ef5数据源 ef5数据源格式前边没有\\
                        if(name[1] == "$"){
                            name = "__dbTags"+name+".PV";
                        }else{
                            name = "__dbTags.$"+name+".PV";
                        }
                        
                        Function(name+" = "+varData.PV)();
                    }
                }
            }.bind(this),1000);
        },
        //获取当前界面点
        getDbvarList(){
            var varListObj = [];
            this.varList = [];
            for(var k in this.$store.state.system.manager){
                if(k != "$"){
                Array.prototype.push.apply(varListObj,this.$store.state.system.manager[k].$.dbVar);
                }
            }
            for(var o=0;o<varListObj.length;o++){
                this.varList.push(varListObj[o].name.split("$").join(""))
            }
        }, 
        onDataPicker(){
            if(this.selectModel == "倒序"){
                this.start = new Date().getTime() - 100000;
                this.end = new Date().getTime();
            }else{
                this.start = new Date(this.times).getTime();//开始时间
                this.end = this.start + 100000;//结束时间加时间跨度
            }
        },
        //开始回放
        startPlayback(open){
            if(this.times =="" ) return alert("没有设置回放时间");
            if(open){
                this.initTime = this.times;
                //回放调用时间开始判断倒序，正序
                this.onDataPicker();
                this.openPlayback = true;
                this.isSelect = true;
                this.playPause = !this.playPause;
                //document.getElementsByClassName("stopStyle")[0].style.color = "#000";
                this.onTimer();
            }
            this.getDbvarList()
            //  console.log(new Date(this.times).getTime())
            var data = {
                "head": "dataLayer",
                "message" : {
                    "head": "getHisData",
                    "varList": this.varList,//["a.PV","b.PV"]
                    "startTime": this.start,//起始时间 Date().GetTime
                    "endTime": this.end,//时间跨度
                    "hisType": 1,  // 0真实历史值, 1 步长历史值
                    "hisStep": 1  //步长单位秒
                }
            }
            this.$store.state.system.$.getHistory(data).then((result) =>{
                if(!this.mark){
                    this.result = result;   
                }else{
                    for(var i =0;i<result.varList.length;i++){
                        // result.varList[i] = result.varList[i].reverse();
                        for(var o=result.varList[i].valueList.length-1; o>=0; o--){
                        //for(var o =0;o<result.varList[i].valueList.length;o++){
                            this.result.varList[i].valueList.unshift(result.varList[i].valueList[o])
                        }
                    }
                }   
            }).catch((reason) =>{
                this.playPause = true;
                this.suspend();
                console.log('失败：' + reason);
            });
        },
        //暂停
        suspend(){
            if(this.playPause == false){
                this.$Message.info('已停止历史回放');
            }
            this.playPause = true;//切换开始和停止
            this.isSelect = false;//启用时间选和下拉框选择
            this.openPlayback = false;//标记ontime标记
            //this.times = this.initTime;
            clearInterval(this.setInt);
        },
        //停止回放
        stopPlayback(){
            document.getElementsByClassName("stopStyle")[0].style.color = "#f10505";
            this.playPause = true;
            this.openPlayback = false;
            this.isSelect = false;
            clearInterval(this.setInt);
        },
        //关闭控件条
        closeControl(){
        this.isShow=false;
        },
        //鼠标按下
        openDrag(){
            let oDiv=document.getElementsByClassName("controlDiv")[0];
            oDiv.onmousedown = function (e) {
                if(oDiv.style.cursor!=="move"){
                    oDiv.style.cursor="move";
                }
                // 鼠标按下，计算当前元素距离可视区的距离
                let disX = e.clientX - oDiv.offsetLeft
                let disY = e.clientY - oDiv.offsetTop
                document.onmousemove = function (e) {
                // 通过事件委托，计算移动的距离
                let l = e.clientX - disX
                let t = e.clientY - disY
                // 移动当前元素
                oDiv.style.left = l + 'px'
                oDiv.style.top = t + 'px'
                
                }
                document.onmouseup = function (e) {
                document.onmousemove = null;
                document.onmouseup = null;
                oDiv.style.cursor="default";

                }
                // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
                return false
            }
        },
        //鼠标抬起
        dragStop () {
            let oDiv=document.getElementsByClassName("controlDiv")[0];
            oDiv.onmouseup = function (e) {
                oDiv.onmousemove = null;
                oDiv.onmousedown = null;
                oDiv.onmouseup = null;
                // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
                return false
            }
        },
        //跳转录屏界面
        /**
        a. 打开 chrome://flags/#unsafely-treat-insecure-origin-as-secure
        b. 搜索Insecure origins treated as secure
        c. 将Disabled改为Enabled，在输入框填写相应的URL，多个URL通过‘，’分开
        d. 修改之后出现relaunch按钮，点击按钮重启浏览器
        */
        record(){
            this.$store.state.system.screencap.$.show();
        }
        
    },
}
</script>
<style>
    .iconStyle{
        display:inline-block;
        font-size:22px;
        color:#000;
    }
    .controlDiv{
        float: left;
    }
    .controlDiv input.ivu-input{
        height:24px;
    }
    .controlDiv .ivu-input-suffix i{
        line-height:24px;
    }
   .controlDiv input,.controlDiv img {vertical-align:middle;}

    .controlDiv>div{
        background: rgb(170, 170, 167);
        border-radius: 3px;
    }
    .iconStyle>i{
        cursor:pointer;
    }
    .iconStyle i:hover{
        color:#092156;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/system/historyPlaybackControl.vue